<script lang="ts">
    export let class_list: string[] = [];
    export let floating: boolean = false;
    export let flat: boolean = false;
    export let size: string = null;
    export let waves: string = "light";
    export let href: string = null;
    export let disabled: boolean = false;
</script>

{#if href}
    <a
        {href}
        on:click
        class="waves-effect waves-{waves} btn
        {size
            ? 'btn-' + size
            : ''}
        {flat ? 'btn-flat' : ''}
        {floating
            ? 'btn-floating'
            : ''}
        {class_list.join(' ')}"
    >
        <slot />
    </a>
{:else}
    <button
        disabled={disabled}
        on:click
        class="waves-effect waves-{waves} btn
        {size
            ? 'btn-' + size
            : ''}
        {flat ? 'btn-flat' : ''}
        {floating
            ? 'btn-floating'
            : ''}
        {class_list.join(' ')}"
    >
        <slot />
    </button>
{/if}
